import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "users",
  initialState: {
    name: "",
    email: "",
    token: "",
    isAuth: false,
  },
  reducers: {
    userName: (state, action) => {
      state.name = action.payload;
    },
    userEmail: (state, action) => {
      state.email = action.payload;
    },
    setAuthentication: (state, action) => {
      state.isAuth = action.payload;
    },
  },
});

export const { userName, userEmail, setAuthentication } = userSlice.actions;

export default userSlice.reducer;
